import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useImperativeHandle, useEffect, createRef, useRef } from 'react';
import useScrollTo from '@segment/utils/useScrollTo';
import useMaskOnScroll from '@segment/utils/useMaskOnScroll';
import useSliderState from './useSliderState';
import { childVariants } from './TestimonialSlider';
import * as views from './Navigation.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var Navigation = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var navigationWrapperRef = useRef(null);

  var _useSliderState = useSliderState(),
      slides = _useSliderState.slides,
      slideToIndex = _useSliderState.slideToIndex,
      activeIndex = _useSliderState.activeIndex;

  var navigationItemsList = useRef(slides.map(function () {
    return /*#__PURE__*/createRef();
  }));
  var scrollTo = useScrollTo(navigationWrapperRef);
  var maskOnScroll = useMaskOnScroll({
    wrapper: navigationWrapperRef
  });
  useImperativeHandle(ref, function () {
    return navigationWrapperRef.current;
  });

  var clickHandler = function clickHandler(i) {
    slideToIndex(i);
    scrollTo(navigationItemsList.current[i]);
  };

  useEffect(function () {
    scrollTo(navigationItemsList.current[activeIndex]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex]);
  return _jsx(views.NavigationWrapper, _objectSpread(_objectSpread({
    className: className,
    variants: childVariants,
    ref: navigationWrapperRef,
    style: {
      WebkitMaskImage: maskOnScroll,
      maskImage: maskOnScroll
    },
    "data-testid": "slider[navigationWrapper]",
    layout: true
  }, rest), {}, {
    children: slides.map(function (_ref2, i) {
      var NavItem = _ref2.navItem,
          props = _ref2.props;
      return _jsx(NavItem, _objectSpread({
        ref: navigationItemsList.current[i],
        active: activeIndex === i,
        activeIndex: activeIndex,
        index: i,
        onClick: function onClick() {
          return clickHandler(i);
        }
      }, props), i);
    })
  }));
});
export default Navigation;